module.exports = __webpack_public_path__ + "static/media/facebook_1200x627.218d70a0.png";